// theme.ts
import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  ...defaultConfig,
  fonts: {
    body: "DM Mono, monospace",
    heading: "DM Mono, monospace",
  },
  globalCss: {
    "::-webkit-scrollbar": {
      width: "10px",
    },
    "::-webkit-scrollbar-track": {
      background: "#1a202c",
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: "#4A5568",
      borderRadius: "8px",
      border: "2px solid #1a202c",
    },
    "::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#718096",
    },
  },
});

export const theme = createSystem(defaultConfig, config);
export default theme;
